var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHintIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09 13.999C4.70066 13.119 4.49969 12.1673 4.5 11.205C4.5 7.50002 7.41 4.49902 11 4.49902C14.59 4.49902 17.5 7.50102 17.5 11.205C17.5003 12.1673 17.2993 13.119 16.91 13.999M11 0.999023V1.99902M21 10.999H20M2 10.999H1M18.07 3.92802L17.363 4.63502M4.637 4.63602L3.93 3.92902M13.517 18.306C14.527 17.979 14.933 17.054 15.047 16.124C15.081 15.846 14.852 15.615 14.572 15.615H7.477C7.40862 15.6139 7.3408 15.6274 7.278 15.6545C7.21521 15.6815 7.15888 15.7217 7.11275 15.7721C7.06662 15.8226 7.03173 15.8823 7.0104 15.9473C6.98906 16.0123 6.98177 16.081 6.989 16.149C7.101 17.077 7.383 17.755 8.453 18.305M13.517 18.306L8.453 18.305M13.517 18.306C13.396 20.251 12.834 21.021 11.007 20.999C9.053 21.035 8.603 20.082 8.453 18.305",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintIcon);
export default __webpack_public_path__ + "static/media/HintIcon.4895eabeee87e06980e173f4af8766ca.svg";
export { ForwardRef as ReactComponent };